<template>
  <v-menu offset-y auto>
    <template #activator="{on, value}">
      <v-btn :class="[classNames, textColor]"
             :rounded="rounded"
             :outlined="outlined"
             :color="color"
             :small="small"
             :x-small="xSmall"
             v-on="on">
        {{ text }}{{ currentlySelected }}
        <app-icon :icon="`expand-${ value ? 'less' : 'more' }`" :size="18"/>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(opt,i) in mappedOptions"
                   :key="i"
                   @click="$emit('updated', {setting, value: options[i]})">
        <v-list-item-title class="text-capitalize">
          {{ opt }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'AppDropDownMenu',

    props: {
      options:           {},
      currentlySelected: {},
      setting:           {},
      color:             { default: '' },
      textColor:         { default: '' },
      classNames:        { default: 'text-capitalize' },
      text:              { default: '' },
      rounded:           { default: false },
      small:             { default: false },
      xSmall:            { default: false },
      mapBy:             { default: null },
      withIcon:          { default: true },
      outlined:          { default: false },
    },

    computed: {
      mappedOptions: function() {
        if(this.mapBy) {
          return this.options.map(opt => opt[this.mapBy])
        }

        return this.options
      },
    },
  }
</script>
